<template>
  <section class="content map">
    <div class="map-wrapper" ref="gMapWrapper">
      <!--      <div v-if="implentationMaterielGeopassages.message !== null" v-bind:class="'callout callout-'+implentationMaterielGeopassages.message.type">
              <p>{{implentationMaterielGeopassages.message.text}}</p>
            </div>-->
      <div class="map-filters row" ref="elFilters">
        <!-- Filter materiel -->
        <div class="form-group col-sm-2">
          <label>Matériel</label>
          <select class="form-control" v-model="implentationContenants.filters.idType"
                  v-on:change="filterByType()">
            <option value=''>Tous</option>
            <option value='CORBEILLE'>Corbeille</option>
            <option value='CANIBOX'>Canibox</option>
            <!--            <option v-for="item in matList" :key="item" :value="item">{{ item | collecteType }}</option>-->
          </select>
        </div>
        <!-- Filter Secteur -->
        <div class="form-group col-sm-2">
          <label>Secteur</label>
          <select class="form-control" v-model="implentationContenants.filters.idSecteur"
                  v-on:change="filterByType()">
            <option value=''>Tous</option>
            <option v-for="item in secteurs.data" :key="item.id" :value="item.id">{{ item.nom }}</option>
          </select>
        </div>
        <div class="form-group col-sm-3">
          <toggle-button
            :value="this.$store.state.implentationContenants.filters.infoWindows"
            :sync="true"
            :labels="{checked: 'Infobulles', unchecked: 'Infobulles'}"
            :color="{checked: '#AADC14', unchecked: '#767C97'}"
            @change="toggleInfowWindows"
            :height="35" :width="120"/>
        </div>
      </div>


      <gmap-map
        ref="map"
        v-if="mounted"
        :center="center"
        :zoom="15"
        map-type-id="roadmap"
        :style="mapStyle"
      >
        <gmap-cluster>
          <gmap-marker
            v-for="(m,i) in implentationContenants.fitredData"
            :icon="{ 'url' : 'static/img/' + getPicto(m) + '.svg' }"
            :position="{ 'lat' : m.lat, 'lng' : m.lon }"
            @click="showInfowindow(m)"
            @mouseover="peakInfowindow(m, true,i)"
            :key='i'>
            <gmap-info-window :opened="(m.opened && implentationContenants.filters.infoWindows )"
                              @closeclick="showInfowindow(m)">
              <div class="title">{{ m.typeContenant | collecteType }} : {{ m.reference }}</div>
              <div>
                <span class="time grey">Moyenne : {{ m.tauxDeRemplissage }} %</span><br/>
                <span class="time grey">Nombre de collectes : {{ m.nombreDeCollecte }}</span><br/>
                <span class="time grey">Dernière collecte : {{ m.lastModif | prettyFullDate }}</span>
              </div>
            </gmap-info-window>
          </gmap-marker>
        </gmap-cluster>
      </gmap-map>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import {matList, arrondList} from '../../../const/index'
// import _ from 'lodash'
// import * as VueGoogleMaps from 'vue2-google-maps'

export default {
  components: {
    Datepicker,
  },
  data: function () {
    return {
      mounted: false,
      showing:null
    }
  },
  computed: {
    ...mapState([
      'secteurs',
      'implentationContenants']),
    mapStyle: function () {
      const h = document.body.clientHeight - 80
      return 'width: 100%; height: ' + h + 'px'
    },
    center: function () {
      return {
        lat: this.$store.state.currentVille.coords.lat,
        lng: this.$store.state.currentVille.coords.lon
      }
    },
  },
  mounted: function () {
    // liste des mat
    this.matList = matList()
    // liste des arrondissements
    this.arrondList = arrondList()
    this.$store.state.implentationContenants.filters.idType = ''
    this.$store.state.implentationContenants.filters.idSecteur = ''
    this.$store.dispatch('fetchSecteursOfVille')
    this.$store.dispatch('fetchContenantsOfVille', {arg: 'implantations'})
    this.mounted = true
    /*     const currentMaitriseArrondissement = this.$store.state
          .currentMaitriseArrondissement
        const filters = this.$store.state.realtime.filters */

    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame
  },

  methods: {
    showInfowindow: function (marker) {
      marker.opened = !marker.opened
    },
    peakInfowindow: function (m, state, i) {
      console.log("peak => " , m)
      console.log("i => " , i)
      console.log("state => " , this.$store.state.implentationContenants.fitredData)
      console.log("showing => " , this.showing)

        if (this.showing == null) {
          this.showing = i
        }
        this.$store.state.implentationContenants.fitredData[this.showing].opened = false
        this.showing = i
        m.opened = true

    },
    getPicto: function (marker) {
      if (marker.typeContenant === 'CORBEILLE') {
        return 'corbeille_arr1'
      } else {
        return 'canibox_arr1'
      }
    },
    toggleInfowWindows: function (event) {
      this.$store.state.implentationContenants.filters.infoWindows = event.value
    },
    filterByType: function () {
      this.showing = null
      console.log('filter by => ', this.$store.state.implentationContenants.filters.idType)
      this.$store.dispatch('filterContenant', {filters: this.$store.state.implentationContenants.filters})
    }
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

.vue-map-container .vue-map {
  margin-top: 80px;
}

.map-wrapper {
  position: relative;

  .tournee-time {
    position: absolute;
    z-index: 10;
    top: 45px;
    left: 10px;
    background-color: white;
    padding: 10px;

    .time-item {
      text-transform: uppercase;
      line-height: 24px;
      height: 24px;

      .mapico {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;
        color: $suez-blue;

        &.debut {
          background-image: url("/static/img/debut-tournee.svg");
        }

        &.fin {
          background-image: url("/static/img/fin-tournee.svg");
        }

        &.pendule {
          background-image: url("/static/img/time.svg");
        }
      }
    }
  }
}

.content.map {
  height: 100%;
}

.vdp-datepicker.form-control {
  -webkit-appearance: menulist-button;
  -moz-appearance: menulist-button;
  appearance: menulist-button;
  width: 180px;
  padding: 0;
  margin: 0;

  input {
    border: none !important;
    padding: 5px;
    width: 160px;
    margin: 2px;
  }
}

.map-wrapper {
  position: relative;

  .row {
    background-color: transparent;
    overflow: visible;
    flex-flow: row wrap;
  }

  .map-filters {
    position: absolute;
    z-index: 1000;
    width: 100%;
    background-color: #ffffff;

    & > div {
      vertical-align: top;
    }

    .row {
      margin: 0 -15px;
      border-radius: 0 0 5px 0;
      background-color: rgba(255, 255, 255, 0.8);
      padding: 20px 15px;

      & > div + div {
        padding-left: 0;
      }
    }

    .form-group {
      margin-bottom: 0;
    }

    .form-control {
      width: 100%;
      display: inline-block;
    }

    label {
      display: block;
    }

    .buttons {
      display: inline-block;
      vertical-align: top;

      @media screen and (min-width: 768px) {
        margin-top: 23px;
      }
      @media screen and (max-width: 767px) {
        margin-bottom: 20px;
      }

      button {
        background-color: $suez-blue;
        background-image: url("/static/img/icon-dl.svg");
        background-repeat: no-repeat;
        background-position: 15px center;
        color: white;
        font-size: 14px;
        font-weight: bold;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border: none;
        padding: 7px 15px 8px 45px;
      }
    }

    .vdp-datepicker.form-control {
      -webkit-appearance: menulist-button;
      -moz-appearance: menulist-button;
      appearance: menulist-button;
      padding: 0;
      margin: 0;

      input {
        border: none !important;
        padding: 5px;
        width: 95%;
        margin: 2px;
        background: none;
      }
    }

    .vdp-datepicker.form-control,
    select {
      background-color: $suez-green-yellowish;
      color: $suez-blue;
      border: none;
      font: 14px/22px "DinMedium";
    }

    label.vue-js-switch {
      font-size: 14px;
      display: inline-block;
      margin: 23px 0 0 0;

      .v-switch-label {
        color: $suez-blue;
        font-weight: normal;
        font-family: "DinMedium";
      }
    }

    .switch {
      width: 100px;
      height: 54px;
      border-radius: 100px;
      background-color: #001051;
      box-shadow: 0 2px 4px 0 rgba(168, 168, 168, 0.2);
      cursor: pointer;
      float: right;

      div {
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center center;
        margin: 3px;
      }

      @mixin on() {
        width: 48px;
        height: 48px;
        border-radius: 40px;
        background-color: #ffffff;
        z-index: 1;
      }
      @mixin off() {
        width: 35px;
        height: 48px;
        border-radius: 40px;
        z-index: 5;
      }

      &.anomalie {
        .materiel {
          background-image: url("/static/img/switch-materiel-off.svg");
          @include off();
        }

        .anomalie {
          background-image: url("/static/img/switch-anomalie-on.svg");
          @include on();
          margin-left: 5px;
          margin-right: 0;
        }
      }

      &.materiel {
        .materiel {
          @include on();
          background-image: url("/static/img/switch-materiel-on.svg");
        }

        .anomalie {
          background-image: url("/static/img/switch-anomalie-off.svg");
          @include off();
          margin-left: -1px;
        }
      }
    }

    @media screen and (max-width: 767px) {
      // position: relative;
      z-index: 1;

      & > div,
      .row > div {
        display: block;
        float: none;
        clear: both;
        width: 100%;
        padding-left: 15px !important;
      }
      .row {
        background: none;
        padding-bottom: 0;
      }
      .form-group {
        padding-bottom: 15px;
      }
      label.vue-js-switch {
        margin-top: 0;
      }
      .switch {
        float: none;
        margin-left: 15px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ImplentationMateriel.vue?3e8bd31d